import SeoServicePage from "@/pages/services/SeoServicePage";

const DentalImplantsPage = () => (
  <SeoServicePage
    slugOverride="dental-implants-cost-kalyan"
    canonicalOverride="/dental-implants-kalyan"
    breadcrumbsOverride={[
      { label: "Advanced Treatments", path: "/services" },
      { label: "Dental Implants Kalyan" },
    ]}
  />
);

export default DentalImplantsPage;